<div class="chat-bot-container" #chatBotContainer>
	<button (click)="op.toggle($event)" pButton pRipple type="button" icon="fa-solid fa-comment" class="p-button-rounded"></button>

	<p-overlayPanel #op [showCloseIcon]="true">
		<ng-template pTemplate>

			<div class="messages-list" #messagesContainer [ngClass]="{'has-messages': messages.length > 0}">
				<div class="message-container" [ngClass]="{'is-bot': message.isBot}"  *ngFor="let message of messages; let i = index;">
					<div class="message" >
						<ng-container *ngIf="!message.isLoading">
							<p class="message-data" [ngClass]="{'message-bot': message.isBot}" [innerHTML]="message.content | linkify"></p>
							<a *ngIf="message.refs?.length > 0 && message.refs[0].page > 0" href="{{message.datasource.link}}?#page={{message.refs[0].page}}" target="_blank" >click here to view document</a>
						</ng-container>
						<span *ngIf="message.isLoading"><i class="fa fa-spin fa-spinner"></i>&nbsp;waiting for response</span>
					</div>
				</div>
			</div>

			<form class="form-ask" [formGroup]="chatForm" (keydown.enter)="sendMessage()">
				<div class="grid">
					<div class="field">
						<label>Choose a document</label>
						<p-dropdown appendTo="body" panelStyleClass="panel-files-dropdown" class="department-dropdown" [options]="dataSources" placeholder="Select an option" formControlName="datasource" optionLabel="label"></p-dropdown>
					</div>
					<div class="field mb-2">
						<label>Ask a question</label>
						<textarea pInputTextarea (keydown.enter)="$event.preventDefault()" class="chat-bot-message" placeholder="Enter your query" formControlName="content"></textarea>
					</div>
					<div class="field text-end">
						<p-button [disabled]="chatForm.invalid" label="Send" (click)="sendMessage()"></p-button>
					</div>
				</div>
			</form>
		</ng-template>
	</p-overlayPanel>
</div>
